import React from 'react';
import {useSelector} from 'react-redux';
import {Table, Card, Loader, Grid} from 'semantic-ui-react';
import './glossary.scss';

const Terms = ({termsList}) => {
  if (!termsList.length) {
    return (
      <Table.Row>
        <Table.Cell textAlign='center' colSpan={2}>
          No hay términos
        </Table.Cell>
      </Table.Row>
    );
  }

  return termsList.map((element, index) => {
    return (
      <Table.Row key={index}>
        <Table.Cell textAlign='center'>{element.term}</Table.Cell>
        <Table.Cell textAlign='center'>{element.meaning}</Table.Cell>
      </Table.Row>
    );
  });
};

const LoaderRow = () => {
  return (
    <Table.Row>
      <Table.Cell colSpan='100%'>
        <Loader active inline='centered' />
      </Table.Cell>
    </Table.Row>
  );
};

const ImagesList = ({imagesList}) => {
  if (imagesList.length) {
    return (
      <Card fluid raised>
        {imagesList.map((image, index) => {
          return (
            <Grid key={index}>
              <Grid.Column width={4}></Grid.Column>
              <Grid.Column width={8}>
                <img
                  className='image'
                  key={index}
                  alt={''}
                  src={`data:image/jpeg;base64, ${image}`}
                />
              </Grid.Column>
            </Grid>
          );
        })}
      </Card>
    );
  }
  return null;
};

const TermsList = (props) => {
  const loading = useSelector((state) => state.templateFTR.loading);
  const glossary = useSelector((state) => state.templateFTR.glossary);
  const termsList = glossary && glossary.terms ? glossary.terms : [];
  const imagesList = glossary && glossary.images ? glossary.images : [];

  return (
    <div className='glossary-tab'>
      <Card fluid raised>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                Palabra/Término
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Significado
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {loading ? <LoaderRow /> : <Terms termsList={termsList} />}
          </Table.Body>
        </Table>
      </Card>

      <ImagesList imagesList={imagesList} />
    </div>
  );
};

export default TermsList;
